<template>
    <!--
      BLOCO S — item 35: "Permitir aos professores controlar as publicações de
      acompanhamentos pedagógicos e desempenhos escolares dos alunos, possibilitando assim
      a consulta pelos alunos, pais e responsáveis."

      A metade dos ACOMPANHAMENTOS veio da FASE 1 (item 109). Esta tela é a metade do
      DESEMPENHO. A publicação é por turma e período — é assim que a escola libera o
      bimestre depois do fechamento.
    -->
    <div class="main">
        <el-form label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="18">
                    <el-form-item label="Instituição" v-if="ehSmed">
                        <el-select v-model="filtro.instituicao_id" @change="carregar()" filterable clearable
                                   placeholder="Pesquisar Instituição" style="width: 100%;">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i"
                                       :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="style-form" v-else>
                        <label>Instituição</label>
                        <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Período">
                        <el-select v-model="filtro.periodo_letivo_id" @change="carregar()" style="width: 100%;">
                            <el-option v-for="(item, i) in $store.state.periodos" :key="i"
                                       :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-alert v-if="erro" :title="erro" type="error" :closable="false" class="u-mb-15"></el-alert>

        <div v-if="carregando" class="u-text-center u-mt-20">Carregando...</div>

        <el-table v-else :data="turmas" border size="mini"
                  empty-text="Nenhuma turma encontrada para os filtros informados.">
            <el-table-column prop="turma" label="Turma" min-width="200"></el-table-column>

            <el-table-column label="Registros de desempenho" width="180">
                <template slot-scope="s">{{ s.row.registros }}</template>
            </el-table-column>

            <el-table-column label="Publicados" width="110">
                <template slot-scope="s">{{ s.row.publicados }}</template>
            </el-table-column>

            <el-table-column label="Situação" width="170">
                <template slot-scope="s">
                    <!--
                      Quatro estados. Turma SEM registro não é "não publicada": é turma sem
                      desempenho lançado, e chamar de "não publicado" sugeriria que existe
                      algo escondido do responsável.
                    -->
                    <el-tag size="mini" :type="tipoTag(s.row.situacao)">{{ rotulo(s.row.situacao) }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="" width="230">
                <template slot-scope="s">
                    <el-button size="mini" type="primary" :disabled="s.row.situacao === 'sem_registro'"
                               @click="definir(s.row, true)">PUBLICAR</el-button>
                    <el-button class="u-ml-10" size="mini" plain :disabled="s.row.publicados === 0"
                               @click="definir(s.row, false)">DESPUBLICAR</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        turmas: [],
        filtro: { instituicao_id: '', periodo_letivo_id: '' },
        carregando: false,
        erro: ''
    }),
    computed: {
        /**
         * O tipo do usuário mora em `state.user`, não em `state.config` — `config` guarda
         * escola e período correntes, e NUNCA teve a chave `usuario`. Lendo o caminho
         * errado, `t` era sempre null e `ehSmed` sempre false: o select de instituição não
         * era renderizado, `filtro.instituicao_id` ficava vazio para perfis de rede (que
         * não têm escola no contexto), a lista de turmas nunca carregava e os botões
         * dependentes de `podeGerar` ficavam desabilitados para sempre.
         *
         * Perfis de abrangência de rede: 4, 5, 6, 7, 8 e 10.
         */
        ehSmed () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.carregar()
    },
    methods: {
        carregar () {
            this.erro = ''
            this.turmas = []

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) return

            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/publicacao-desempenho/situacao/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`,
                            this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}
                if (d.erro || d.error) { this.erro = d.erro || d.error; return }
                this.turmas = d.turmas || []
            }).catch(e => { this.carregando = false; this.tratarFalha(e) })
        },

        definir (linha, publicar) {
            const acao = publicar ? 'publicar' : 'despublicar'

            const texto = publicar
                ? `Publicar o desempenho da turma "${linha.turma}" para pais e alunos?`
                : `Remover o desempenho da turma "${linha.turma}" do portal? Pais e alunos deixarão de ver.`

            this.$confirm(texto, 'Confirmação', { type: 'warning' }).then(() => {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/publicacao-desempenho/${acao}/${linha.turma_id}/${linha.periodo_letivo_id}`,
                                 {}, this.$store.getters.getHeaderAuth).then(r => {
                    const d = r.data || {}

                    if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }

                    this.$message.success(d.mensagem)

                    // Aviso de "nenhum registro afetado" é mostrado, não escondido atrás do sucesso.
                    if (d.aviso) this.$message.warning(d.aviso)

                    this.carregar()
                }).catch(e => this.tratarFalha(e))
            }).catch(() => {})
        },

        rotulo (s) {
            return { publicado: 'Publicado', nao_publicado: 'Não publicado',
                     parcial: 'Parcialmente publicado', sem_registro: 'Sem desempenho lançado' }[s] || s
        },

        tipoTag (s) {
            return { publicado: 'success', nao_publicado: 'info',
                     parcial: 'warning', sem_registro: 'info' }[s] || 'info'
        },

        tratarFalha (e) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            this.$message.error(d.erro || d.error || 'Não foi possível concluir a operação.')
        }
    }
}
</script>

<style scoped>
</style>
